const INITIAL_INPUT = {
    type: 'text',
    title: '',
    target: 'athlete',
    required: false,
}

const INITIAL_VOLUNTEER_INPUT = {
    type: 'text',
    title: '',
    target: 'volunteer',
    required: false,
}

const TYPE_VALUES = [
    { label: 'Text', value: 'text' },
    { label: 'Number', value: 'number' },
    { label: 'Image or PDF', value: 'image' },
    { label: 'List', value: 'list' },
]

const TARGET_VALUES = [
    { label: 'Athlete', value: 'athlete' },
    { label: 'Team', value: 'team' },
]

const TARGET_VOLUNTEER_VALUES = [{ label: 'Volunteer', value: 'volunteer' }]

// Templates prédéfinis pour simplifier la création
const CUSTOM_INPUT_TEMPLATES = [{
        id: 'tshirt-size',
        input: {
            type: 'list',
            titleKey: 'template.tshirt-size.title',
            target: 'athlete',
            required: false,
            options: ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'],
        },
    },
    {
        id: 'license-number',
        input: {
            type: 'text',
            titleKey: 'template.license-number.title',
            target: 'athlete',
            required: false,
        },
    },
    {
        id: 'id-photo',
        input: {
            type: 'image',
            titleKey: 'template.id-photo.title',
            target: 'athlete',
            required: false,
        },
    },
    {
        id: 'medical-certificate',
        input: {
            type: 'image',
            titleKey: 'template.medical-certificate.title',
            target: 'athlete',
            required: false,
        },
    },
    {
        id: 'emergency-contact',
        input: {
            type: 'text',
            titleKey: 'template.emergency-contact.title',
            target: 'athlete',
            required: false,
        },
    },
    {
        id: 'team-name',
        input: {
            type: 'text',
            titleKey: 'template.team-name.title',
            target: 'team',
            required: false,
        },
    },
    {
        id: 'age-category',
        input: {
            type: 'list',
            titleKey: 'template.age-category.title',
            target: 'athlete',
            required: false,
            options: ['U18', '18-24', '25-34', '35-44', '45-54', '55+'],
        },
    },
    {
        id: 'club-name',
        input: {
            type: 'text',
            titleKey: 'template.club-name.title',
            target: 'athlete',
            required: false,
        },
    },
]

export default {
    INITIAL_INPUT,
    TYPE_VALUES,
    TARGET_VALUES,
    INITIAL_VOLUNTEER_INPUT,
    TARGET_VOLUNTEER_VALUES,
    CUSTOM_INPUT_TEMPLATES,
}